import React, { Component } from 'react';
import { connect } from 'react-redux';
import { actions } from '../../config/reduxIndex';
import CurrentNotes from '../../components/notes/CurrentNotes';

/**
 * Renders: {@link CurrentNotes}
 * @props notes - redux -> state.notes
 * @props {function} closeOverlay - redux -> notes.closeNotesOverlay()
 * @props {function} addNewNote - redux -> notes.addNewNote()
 * @returns CurrentNotes
 */
class CurrentNotesContainer extends Component {
	render() {
		const { notes, closeOverlay } = this.props;
		return <CurrentNotes 
			notes = { notes.notesList }
			isLoading = { notes.isLoading }
			closeOverlay = { closeOverlay }
			addNewNote = { this.addNewNote }
		/>;
	}

	addNewNote = () => {
		const { addNewNote } = this.props;
		addNewNote();
	}
}

function mapStateToProps(state) {
	return {
		notes: state.notes
	}
}

const mapDispatchToProps = dispatch => {
	return {
		closeOverlay: () => {
			dispatch(actions.notes.closeNotesOverlay());
		},
		addNewNote: () => {
			dispatch(actions.notes.addNewNote())
		}
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(CurrentNotesContainer);


// WEBPACK FOOTER //
// ./src/containers/notes/CurrentNotesContainer.jsx